import React, { Component } from 'react';

import { LoadableComponentErrorBoundaryPage } from './LoadableComponentErrorBoundaryPage';

const CHUNK_RELOAD_STORAGE_KEY = 'bx-chunk-reload-ts';
const CHUNK_RELOAD_COOLDOWN_MS = 30000;

// Use ErrorBoundary to catch ChunkLoadError
// https://reactjs.org/docs/error-boundaries.html
class LoadableComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (error?.name !== 'ChunkLoadError' || typeof window === 'undefined') {
      return;
    }

    const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY) || 0);
    const now = Date.now();
    if (!lastReload || now - lastReload > CHUNK_RELOAD_COOLDOWN_MS) {
      sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(now));
      window.location.reload();
    }
  }

  render() {
    if (this.state.error?.name === 'ChunkLoadError') {
      return <LoadableComponentErrorBoundaryPage />;
    }

    return this.props.children;
  }
}

export default LoadableComponentErrorBoundary;
